import { render, staticRenderFns } from "./set-evaluations-date.vue?vue&type=template&id=06006711&"
import script from "./set-evaluations-date.js?vue&type=script&lang=js&"
export * from "./set-evaluations-date.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports